module.exports = __webpack_public_path__ + "img/A Socially Equitable Energy Transition in Indonesia.fd78de44.jpg";